import { render, staticRenderFns } from "./EvaluationSimpleCell.vue?vue&type=template&id=01198ce2&scoped=true&"
import script from "./EvaluationSimpleCell.vue?vue&type=script&lang=js&"
export * from "./EvaluationSimpleCell.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationSimpleCell.vue?vue&type=style&index=0&id=01198ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01198ce2",
  null
  
)

export default component.exports